import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Bed = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="bed icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3H2V9H23C23.5523 9 24 9.44772 24 10V15V16V21H22V17H2V21H0L0 16L0 10L0 3ZM4 5C3.44772 5 3 5.44772 3 6V7C3 7.55228 3.44772 8 4 8H8C8.55228 8 9 7.55228 9 7V6C9 5.44772 8.55228 5 8 5H4Z"
    />
  </svg>
)
